import { Helmet } from "react-helmet";
import React, { Component } from 'react';
import "../../styles/customers/customers.scss"
import { Button, FormControl } from 'react-bootstrap';
import CustomerTable from "./customerTable";
import axios from "axios";
import { encodeQueryData, apiHost } from "../../api/apiClient";
import Layout from '../../Layout/layout';
import { setLoadingPage, setErrorMessage } from '../../reducers/actions';
import { connect } from 'react-redux';
import RoleAccessBadge from "../common/roleAccessBadge";

class Customers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            customerList: [],
            customerLength: 0,
            customerBoolean: true,
            searchListLength: 0,
            searchBadgeBoolean: false,
            searchText: "",
            statusFilter: "all",
        };
        this.sortDirection = '';
        this.sortString = '';
        this.searchText = "";

    }

    async componentDidMount() {
        this.props.setLoadingPageAction(true);

        try {
            const response = await axios.get(`${apiHost}/api/Customer/GetAllCustomers?AllRecords=true&SortDirection=asc&SortString=name`, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("token")
                }
            });
            this.setState({ customerList: response.data })
            if (this.state.customerBoolean) {

                this.setState({
                    customerLength: response.data.length,
                    customerBoolean: false,
                });

            }
            this.props.setLoadingPageAction(false);

        } catch (e) {
            if (e.response.status == "401") {
                this.props.history.push("/login");
            } else {
                this.props.setErrorMessageAction(`${e}`)

            }
            this.props.setLoadingPageAction(false);
        }
    }

    handleCreateCustomer = () => {
        this.props.history.push("/createCustomer")
    }

    handleDetail = (id) => {
        this.props.history.push(`/customerDetail/${id}`)
    }

    handleSort = (name, order) => {
        this.sortString = name;
        this.sortDirection = order;
        let query = encodeQueryData(this.setCustomersQueryObject());
        let urlAll = `${apiHost}/api/Customer/GetAllCustomers?${query}`;
        this.getCustomer(urlAll);
    }

    setCustomersQueryObject = () => {
        let data = {};
        data.AllRecords = true;
        data.SearchString = this.searchText;
        data.SortDirection = this.sortDirection;
        data.SortString = this.sortString;
        return data;
    };

    getCustomer = async (url) => {
        try {
            const response = await axios.get(url, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("token")
                }
            });
            this.setState({ customerList: response.data })
            if (this.state.customerBoolean) {

                this.setState({
                    customerLength: response.data.length,
                    customerBoolean: false,
                });

            }
            this.props.setLoadingPageAction(false);

        } catch (e) {
            if (e.response.status == "401") {
                this.props.history.push("/login");
            } else {
                this.props.setErrorMessageAction(`${e}`)

            }
            this.props.setLoadingPageAction(false);
        }
    }

    handleSearch = async (searchText) => {

        if (searchText == '') {
            this.setState({
                searchBadgeBoolean: false,
                searchText
            })
        } else {
            this.setState({
                searchBadgeBoolean: true,
                searchText
            })
        }
        this.searchText = searchText;
        let query = encodeQueryData(this.setCustomersQueryObject());
        let urlAll = `${apiHost}/api/Customer/GetAllCustomers?${query}`;

        this.props.setLoadingPageAction(true);
        try {
            const response = await axios.get(urlAll, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("token")
                }
            });
            this.setState({
                customerList: response.data,
                searchListLength: response.data.length
            });

            this.props.setLoadingPageAction(false);

        } catch (e) {
            if (e.response.status == "401") {
                this.props.history.push("/login");
            } else {
                this.props.setErrorMessageAction(`${e}`)

            }
            this.props.setLoadingPageAction(false);
        }
    }

    handleStatusFilter = (statusFilter) => {
        this.setState({ statusFilter });
    }

    getCustomerStatus = (customer) => {
        return (customer.status || "").toString().toLowerCase();
    }

    getStatusCounts = () => {
        const { customerList } = this.state;
        const active = customerList.filter((customer) => this.getCustomerStatus(customer) === "active").length;
        const disabled = customerList.filter((customer) => this.getCustomerStatus(customer) === "disabled").length;

        return {
            all: customerList.length,
            active,
            disabled,
        };
    }

    getFilteredCustomers = () => {
        const { customerList, statusFilter } = this.state;

        if (statusFilter === "all") {
            return customerList;
        }

        return customerList.filter((customer) => this.getCustomerStatus(customer) === statusFilter);
    }

    render() {
        const { searchText, statusFilter } = this.state;
        const filteredCustomers = this.getFilteredCustomers();
        const statusCounts = this.getStatusCounts();

        return (
            <React.Fragment>
                <Layout>

                    <Helmet>
                        <title>Customers SPA </title>

                    </Helmet>
                    <div className="contentBody">
                        <div className="contentWrapper customer-page">
                            <div className="customer-page-header">
                                <div>
                                    <h2>Customers</h2>
                                    <p>Manage customer records, linked assets, users, devices and groups.</p>
                                </div>
                                <div className="customer-header-actions">
                                    <RoleAccessBadge role="SystemAdmin" />
                                    <Button className="customer-create-button" variant="primary" onClick={() => this.handleCreateCustomer()}>
                                        <i className="fa fa-plus"></i>
                                        Create new
                                    </Button>
                                </div>
                            </div>

                            <div className="customer-toolbar">
                                <div className="customer-search">
                                    <i className="fa fa-search"></i>
                                    <FormControl
                                        placeholder="Search customers by name, description or status"
                                        aria-label="Start typing to filter customers"
                                        aria-describedby="basic-addon2"
                                        onChange={(e) => this.handleSearch(e.target.value)}
                                        value={searchText}
                                    />
                                    {searchText && (
                                        <button onClick={() => this.handleSearch("")} type="button">
                                            <i className="fa fa-times"></i>
                                        </button>
                                    )}
                                </div>
                                <div className="customer-status-filter" role="group" aria-label="Filter customers by status">
                                    {[
                                        { key: "all", label: "All", count: statusCounts.all },
                                        { key: "active", label: "Active", count: statusCounts.active },
                                        { key: "disabled", label: "Disabled", count: statusCounts.disabled },
                                    ].map((item) => (
                                        <button
                                            className={statusFilter === item.key ? "active" : ""}
                                            key={item.key}
                                            onClick={() => this.handleStatusFilter(item.key)}
                                            type="button"
                                        >
                                            <span>{item.label}</span>
                                            <strong>{item.count}</strong>
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="customers customer-table-shell">
                                <CustomerTable
                                    customers={filteredCustomers}
                                    onDetail={this.handleDetail}
                                    sortFunction={this.handleSort}
                                >
                                </CustomerTable>



                            </div>

                        </div></div>
                </Layout>
            </React.Fragment>


        );
    }

}

const mapStateToProps = (state) => ({

    loading: state.loading

})
const mapDispatchToProps = {
    setLoadingPageAction: setLoadingPage,
    setErrorMessageAction: setErrorMessage


}

export default connect(mapStateToProps, mapDispatchToProps)(Customers);
